module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "valid-icon.e926ba23.svg";